export const Channel = {
  AppNotification: {
    id: "fetias",
    name: "App Notification",
    value: "fetias",
    icon: ["far", "bell"]
  },
  Email: {
    id: "email",
    name: "Email",
    value: "email",
    icon: ["far", "envelope"]
  },
  SMS: {
    id: "sms",
    name: "SMS",
    value: "sms",
    icon: ["far", "comment"],
    beta: true
  },
  Slack: {
    id: "slack",
    name: "Slack",
    value: "slack",
    icon: ["fab", "slack"],
    internal: true
  },
  WhatsApp: {
    id: "whatsapp",
    name: "WhatsApp",
    value: "whatsapp",
    icon: ["fab", "whatsapp"],
    internal: true
  },
  CloudMessage: {
    id: "cloudMessaging",
    name: "Cloud Message (FCM)",
    value: "cloudMessaging",
    icon: ["fas", "server"],
    internal: true
  }
}

const statusText = (val) => {
  switch (val) {
    case 0:
      return "Pending";
    case 1:
      return "Delivered";
    case 2:
      return "Aborted";
    // Attempted and errored, as opposed to Aborted (refused). Rows that used to sit on Pending
    // forever land here now — nothing retries them.
    case 3:
      return "Failed";
  }
}

const channelIcon = (val) => {
  switch (val) {
    case 0:
      return Channel.AppNotification.icon;
    case 1:
      return Channel.Email.icon;
    case 2:
      return Channel.Slack.icon;
    case 3:
      return Channel.SMS.icon;
    case 4:
      return Channel.WhatsApp.icon;
  }
}

const channelText = (val) => {
  switch(val) {
    case 0:
      return Channel.AppNotification.name;
    case 1:
      return Channel.Email.name;
    case 2:
      return Channel.Slack.name;
    case 3:
      return Channel.SMS.name;
    case 4:
      return Channel.WhatsApp.name;
  }
}

export default {
  channels: Object.values(Channel),
  statusText: statusText,
  channelIcon: channelIcon,
  channelText: channelText,
}